import React from "react";
import LegalPage from "../Legal/LegalPage";

const sections = [
  {
    title: "What we do with your information",
    paragraphs: [
      "When you make a purchase, we collect the personal information needed for the transaction, including details such as your name, address, and email address.",
      "When you browse the website, we may automatically receive your device's Internet Protocol (IP) address and related browser or operating-system information. If you give permission, we may also email you about products, services, and updates.",
    ],
  },
  {
    title: "Consent",
    paragraphs: [
      "When you provide personal information to complete a transaction, verify payment, place an order, arrange delivery, or process a return, you consent to its use for that purpose. For secondary purposes such as marketing, we will request permission or provide a way to decline.",
      "You may withdraw consent for further contact, collection, use, or disclosure by emailing sj135637@gmail.com or writing to MAXXTEK SOLUTIONS, Karamatiya Market, Jalalpur, Uttar Pradesh, India 224149.",
    ],
  },
  {
    title: "Disclosure",
    paragraphs: [
      "We may disclose personal information when required by law or when our Terms of Service are violated.",
    ],
  },
  {
    title: "Payment",
    paragraphs: [
      "Card information is not stored on our servers. Payment data is encrypted and processed in accordance with the Payment Card Industry Data Security Standard (PCI-DSS). Transaction information is retained only for as long as necessary to complete the purchase.",
      "Our payment gateway follows PCI-DSS standards managed by the PCI Security Standards Council to support the secure handling of card information.",
    ],
  },
  {
    title: "Third-party services",
    paragraphs: [
      "Third-party providers generally collect, use, and disclose information only as needed to perform their services. Payment gateways and transaction processors may apply their own privacy policies, which you should review before completing a transaction.",
      "A provider may operate in another jurisdiction, making your information subject to that jurisdiction's laws. External websites and applications have their own privacy practices, and we are not responsible for their content or policies.",
    ],
  },
  {
    title: "Security",
    paragraphs: [
      "We take reasonable precautions and follow accepted industry practices to protect personal information from inappropriate loss, misuse, access, disclosure, alteration, or destruction.",
    ],
  },
  {
    title: "Cookies",
    paragraphs: [
      "We use cookies to maintain your user session. These cookies are not used to identify you personally on unrelated websites.",
    ],
  },
  {
    title: "Age of consent",
    paragraphs: [
      "By using this website, you confirm that you are at least the age of majority where you live, or that you have consented to allow your minor dependants to use the website.",
    ],
  },
  {
    title: "Changes to this privacy policy",
    paragraphs: [
      "We may update this policy at any time. Changes take effect when posted here. Material updates will be identified on this page so you can understand what information is collected, how it is used, and when it may be disclosed.",
      "If the business is acquired or merged with another company, information may be transferred to the new owner so services can continue.",
    ],
  },
  {
    title: "Questions and contact information",
    paragraphs: [
      "For questions about this Privacy Policy or the handling of your information, contact us at sj135637@gmail.com.",
    ],
  },
];

const Privacy = () => (
  <LegalPage eyebrow="Your data" title="Privacy Policy" sections={sections} />
);

export default Privacy;
